import React, { useContext, useState } from 'react';
import { useQuery } from '@apollo/client';
import { GET_COMPANIES } from '../../utils/api/company';
import { Button, Select, Tag } from 'antd';
import { GET_COMPANY_USERS } from '../../utils/api/user';
import FormModal from '../modals/FormModal';
import { useCurrentUser } from '../../utils/CurrentUserContext';
import { Controller, useWatch } from 'react-hook-form';
import FormItem from '../forms/utils/FormItem';
import { SuperAdminContext } from '../../AuthorizedApolloProvider';
import { CompanyType, UserRole } from '../../__generated__/graphql';

const UserSelect = () => {
  const companyId = useWatch({ name: 'companyId' })

  const {data: dataUsers, loading} = useQuery(GET_COMPANY_USERS, {variables: {perPage: 100, filters: {companyId: companyId?.value}}, skip: !companyId});

  if (!companyId) {
    return null
  }
  const users = dataUsers ? dataUsers.users.items : [];
  const groupedUsers = [UserRole.Guest, UserRole.RegularUser, UserRole.AccountAdmin, UserRole.SuperAdmin].map((type) => ({
    label: type,
    options: users.filter((user: any) => user.role === type)
  }))
  return (
    <FormItem top label="User" >
    <Controller
      name='userId'
      render={({ field: { value, onChange } }) => (
        <Select loading={loading} showSearch optionFilterProp='label' className='w-[300px]' value={value} options={groupedUsers} onChange={onChange} labelInValue/>
      )}
    />
  </FormItem>
  )
}
const AccountSelector = () => {
  const {isSuperAdmin} = useCurrentUser()
  const {impersonatedUser, setImpersonatedUser} = useContext(SuperAdminContext)
  const [showModal, setShowModal] = useState(false);
  const {data, loading} = useQuery(GET_COMPANIES, {variables: {perPage: 1000}, skip: !showModal});

  const companies = data ? data.companies.items : [];

  const groupedCompanies = [CompanyType.Advertiser, CompanyType.Agency, CompanyType.Publisher].map((type) => ({
    label: type,
    options: companies.filter((company: any) => company.type === type)
  }))

  const onOk = (values: any) => {
    setShowModal(false)

    setImpersonatedUser(values)
  }

  if (!isSuperAdmin) {
    return null
  }

  return (
    <>
      {impersonatedUser ? (
        <Tag color="green" closable onClose={() => setImpersonatedUser(null as any)}>Acting as {(impersonatedUser as any).userId?.label || 'yourself'}({(impersonatedUser as any).companyId.label})</Tag>
      ) : (
        <Button type='link' onClick={() => setShowModal(true)}>Impersonate a user</Button>
      )}
      <FormModal
        title='Impersonate a user'
        open={showModal}
        onCancel={() => setShowModal(false)}
        onOk={onOk}
        skipDirtyValidation
        okText='Impersonate'
      >

        <FormItem top label="Company">
          <Controller
            name='companyId'
            render={({ field: { value, onChange } }) => (
              <Select loading={loading} showSearch optionFilterProp='label' className='w-[300px]' value={value} options={groupedCompanies} onChange={onChange} labelInValue/>
            )}
          />
        </FormItem>
        <UserSelect />
      </FormModal>
    </>
  );
};

export default AccountSelector;

